"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MESSAGE_METHOD_CONFLICT = exports.MESSAGE_MODULEID_MISSING = exports.MESSAGE_BUS_CONFLICT = exports.MESSAGE_REQUEST_TIMEOUT = exports.RESPONSE_KEY = exports.REGIST_KEY = exports.MESSAGE_KEY = void 0;
exports.MESSAGE_KEY = 'CORS_BUS';
exports.REGIST_KEY = '$registBus';
exports.RESPONSE_KEY = '$response';
exports.MESSAGE_REQUEST_TIMEOUT = '请求超时';
exports.MESSAGE_BUS_CONFLICT = '模块 "{id}" 已存在';
exports.MESSAGE_MODULEID_MISSING = '模块id缺失';
exports.MESSAGE_METHOD_CONFLICT = '方法 "{method}" 已存在';
//# sourceMappingURL=consts.js.map